<div class="modal-header">
  <h4 class="modal-title" *ngIf="!onlyView">Programar Férias</h4>
  <h4 class="modal-title" *ngIf="onlyView">Aprovação - Programação de Férias</h4>
  <button type="button" (click)="onDismiss()" class="close" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" tabindex="0" ngbAutofocus>
  <div class="row">
    <div class="col-12">
      <form class="form-horizontal" [formGroup]="form" #frm>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="form-control-label"class="form-control-label cursor-pointer" for="date" popoverTitle="Início do Gozo de Férias"
                ngbPopover="Permitido até 3 programações. Deve respeitar os dias do período selecionado.
              A programação deve ser realizada pelo menos 30 dias antes do início do gozo de férias."
                triggers="mouseenter:mouseleave"><span [data-feather]="'info'"></span> Data da Programação</label>
              <input type="date" id="date" formControlName="date" required class="form-control" />
              <app-error-msg [control]="form.controls['date']" [label]="'date'"> </app-error-msg>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label class="form-control-label"class="cursor-pointer" for="amountDaysVacation" popoverTitle="Férias" ngbPopover="Pelo menos uma programação deve conter 14 ou mais dias corridos.
              Não é permitida programação inferior a 5 dias corridos." triggers="mouseenter:mouseleave"><span
                  [data-feather]="'info'"></span> Quantidade de dias - Férias</label>
              <input type="text" id="amountDaysVacation" formControlName="amountDaysVacation" required
                class="form-control" mask="99" (keypress)="omitChar($event)" />
              <app-error-msg [control]="form.controls['amountDaysVacation']" [label]="'amountDaysVacation'">
              </app-error-msg>
            </div>
          </div>
          <div class="col-12" *ngIf="lockAllowanceDays">
            <div class="form-group">
              <div class="custom-control custom-switch">
                <p class="mb-50 custom-font-size cursor-pointer" popoverTitle="Abono Pecuniário"
                  ngbPopover="Ao solicitar abono pecuniário, a quantidade é fixa de 10 dias."
                  triggers="mouseenter:mouseleave">
                  <span [data-feather]="'info'"></span> Solicitar Abono Pecuniário?
                </p>
                <input type="checkbox" class="custom-control-input" id="hasAllowance"
                  [checked]="hasAllowance" [disabled]="onlyView" (change)="onAllowanceChange($event)" />
                <label class="form-control-label"class="custom-control-label" for="hasAllowance">
                  <span class="switch-icon-left"><i data-feather="check"></i></span>
                  <span class="switch-icon-right"><i data-feather="x"></i></span>
                </label>
              </div>
              <small *ngIf="hasAllowance" class="text-muted d-block mt-50">
                Abono fixo de 10 dias conforme política da empresa.
              </small>
            </div>
          </div>
          <div class="col-12" *ngIf="!lockAllowanceDays">
            <div class="form-group">
              <label class="form-control-label"class="cursor-pointer" for="amountDaysAllowance" popoverTitle="Abono Pecuniário"
                ngbPopover="Limitado a 1/3 dos dias de saldo, com máximo de 10 dias."
                triggers="mouseenter:mouseleave"><span [data-feather]="'info'"></span> Quantidade de dias -
                Abono</label>
              <input type="text" id="amountDaysAllowance" formControlName="amountDaysAllowance" required
                class="form-control" mask="99" (keypress)="omitChar($event)" />
              <app-error-msg [control]="form.controls['amountDaysAllowance']" [label]="'amountDaysAllowance'">
              </app-error-msg>
            </div>
          </div>
          <div class="col-12" *ngIf="showJustificationInput">
            <div class="form-group">
              <label class="form-control-label" for="allowanceReason">Justificativa</label>
              <textarea id="allowanceReason" formControlName="allowanceReason" class="form-control" rows="3"
                placeholder="Justificativa do Abono"></textarea>
              <app-error-msg [control]="form.controls['allowanceReason']" [label]="'allowanceReason'"></app-error-msg>
            </div>
          </div>
          <div class="col-12" *ngIf="vacationManagementParameters.maximumPrepaymentPercent > 0">
            <div class="form-group">
              <div class="custom-control custom-switch">
                <p *ngIf="!vacationManagementParameters.lockPrepaymentPercent" class="mb-50 custom-font-size">Antecipa Décimo?</p>
                <p *ngIf="vacationManagementParameters.lockPrepaymentPercent" class="mb-50 custom-font-size cursor-pointer" popoverTitle="Antecipação de Décimo"
                  ngbPopover="Ao solicitar a antecipação do 13º salário, o percentual é fixado em {{vacationManagementParameters.maximumPrepaymentPercent}}%."
                  triggers="mouseenter:mouseleave">
                  <span [data-feather]="'info'"></span> Antecipa Décimo?
                </p>
                <input type="checkbox" class="custom-control-input" id="hasPrepayment" (change)="hasPrepaymentChange($event)" [checked]="hasPrepayment"/>
                <label class="form-control-label"class="custom-control-label" for="hasPrepayment">
                  <span class="switch-icon-left"><i data-feather="check"></i></span>
                  <span class="switch-icon-right"><i data-feather="x"></i></span>
                </label>
              </div>
            </div>
          </div>
          <div class="col-12" *ngIf="hasPrepayment && !vacationManagementParameters.lockPrepaymentPercent">
            <div class="form-group">
              <label class="form-control-label"class="form-control-label cursor-pointer" for="prepaymentPercent13S" popoverTitle="Antecipação de Décimo"
                ngbPopover="Permitido até 3 antecipações (1 para cada programação). A soma das antecipações deve respeitar 
                o limite permitido pela empresa ({{vacationManagementParameters.maximumPrepaymentPercent}}%).
                Programações de novembro e dezembro não podem solicitar antecipação de décimo terceiro."
                triggers="mouseenter:mouseleave"><span [data-feather]="'info'"></span> Percentual de Antecipação (Décimo)</label>
              <input type="text" class="form-control" formControlName="prepaymentPercent13S" mask="99"
                (keypress)="omitChar($event)" suffix=" %"/>
              <app-error-msg [control]="form.controls['prepaymentPercent13S']" [label]="'percentualAdianto13S'">
              </app-error-msg>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div *ngIf="!onlyView" class="modal-footer">
  <button type="button" class="btn btn-outline-danger" (click)="onDismiss()" rippleEffect>
    Cancelar
  </button>
  <button type="button" (click)="handleSubmit()" #btnConfirm class="btn btn-success" rippleEffect>
    {{actionText}}
  </button>
</div>

<div *ngIf="onlyView" class="modal-footer">
  <button type="button" class="btn btn-outline-danger" (click)="openApproveVacationSchedule(2)" rippleEffect>
    Rejeitar
  </button>
  <button type="button" (click)="openApproveVacationSchedule(1)" #btnConfirm class="btn btn-success" rippleEffect>
    Aprovar
  </button>
</div>